import { componentMap, variantHandler, components, variants } from '@blaze-cms/react-page-builder';
import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
async function load(app) {
  app.events.once('load:custom:page-builder:component', addComponent => {
    Object.keys(components).forEach(key => addComponent({
      key,
      component: components[key]
    }));
  });
  app.events.once('plugin:page-builder-fe:load:loaded', async () => {
    if (!componentMap.getAll().length) {
      // componentMap and variantHandler are singletons so only populate once
      await app.events.emitAsync('load:custom:page-builder:component', componentMap.add);
      await app.events.emitAsync('load:custom:page-builder:variant', variantHandler.add);

      // add core variants last so they can be overridden
      Object.keys(variants).forEach(variantKey => {
        const variant = variants[variantKey];
        variantHandler.add(variantKey, variant);
      });
    }
  });
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
export { buildPBComponents, getLightboxImages } from '@blaze-cms/react-page-builder';
export default load;
//# sourceMappingURL=index.js.map